import layeredSoilAttribute from './layeredSoilAttribute';

const waterStorage = (allLayers: boolean) =>
  layeredSoilAttribute({
    aggregationMethod: 'Weighted Average',
    allLayers,
    key: 'Available Water Storage',
    ratingCol: {
      displayString: 'Water storage (cm)',
      accessor: 'mapUnitRatingString',
    },
    ruleId: '101',
    units: 'cm',
  });

export const WATER_STORAGE_ALL_LAYERS = waterStorage(true);
export const WATER_STORAGE_SURFACE_LAYER = waterStorage(false);
